<template>
    <div style="height: 80px; width: 100%"></div>
  <div>
    <img style="width: 100%" src="@/images/rjxtban2.png" alt="" />
  </div>
  <div class="title">
    <h1>软件系统</h1>
    <div class="heng"></div>
  </div>
  <div class="background">
    <div class="background_box">
      <img style="width:100%;height:100%" src="@/images/6432c8a699dd65aeaaf3cad4bf7ca30.png" alt="">

    </div>
    <div class="background_box">
      <ul>
        <h2>DC-WMS仓库管理系统</h2>
        <li>提供专业的仓储管理功能</li>
        <li>助力实现自动化仓储运营</li>
        <li>定制化开发，适配特定需求</li>
        <li>地部署，保护系统与数据安全</li>
        <li>快速对接，匹配企业管理系统</li>
      </ul>
    </div>

  </div>
    <div class="background">

    <div class="background_box">
       <ul>
        <h2>读码校验设备管理系统</h2>
        <li>与 WMS 系统深度联动，实现数据实时闭环</li>
        <li>多码制兼容与智能识别，适配全场景读码需求</li>
        <li>自定义校验规则，适配行业个性化场景</li>
        <li>自动化异常处理，提升作业容错效率</li>
        <li>数据安全与权限管控，符合本地化部署要求</li>
        <li>跨设备协同，赋能自动化仓储链路</li>
      </ul>
    </div>
    <div class="background_box">
      <img style="width:100%;height:100%" src="@/images/5a0a02be8a326819eecfe3cdd1b9192.png" alt="">

    </div>
  </div>
</template>

<script>
export default {

}
</script>
<style scoped>
.heng {
  background-color: rgb(0, 0, 0);
  width: 50px;
  height: 6px;
  border-radius: 10px;
}

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.background{
  margin: 30px auto;
  width: 60%;
  height:325px ;

  display: flex;
}
.background_box{
  width: 50%;
  height:100% ;
  background-color: rgba(186, 186, 186, 0.23);

}
li{
  margin: 10px 60px 0px 40px;
}
</style>